import get from "lodash.get";

export const getAssetURLMapping = (data, isWebPSupported = false, isHighRes) =>
  get(data, "includes.Asset", []).reduce((agg, asset) => {
    const id = get(asset, "sys.id");

    const url = `https:${get(asset, "fields.file.url")}?q=${
      isHighRes ? "80" : "60"
    }${isWebPSupported ? "&fm=webp" : ""}`;
    agg[id] = url;
    return agg;
  }, {});

export const getEntryURLMapping = (data) =>
  get(data, "includes.Entry", []).reduce((agg, entry) => {
    const id = get(entry, "sys.id");
    agg[id] = entry;
    return agg;
  }, {});
